function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import { sync } from 'vuex-pathify';
import template from './susvimo-product-detail.html';

var SusvimoProductDetail = /*#__PURE__*/function () {
  function SusvimoProductDetail() {
    _classCallCheck(this, SusvimoProductDetail);
  }

  _createClass(SusvimoProductDetail, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-susvimo-product-detail', {
        template: template,
        props: {
          labels: {
            type: Object,
            "default": function _default() {}
          },
          rules: {
            type: Object
          },
          variant: {
            type: String,
            "default": ''
          }
        },
        data: function data() {
          return {
            nullableFields: [{
              key: 'batchNumber',
              options: {}
            }, {
              key: 'unitsAffected',
              options: {
                pattern: '^[1-9]\\d*$',
                type: 'number'
              }
            }, {
              key: 'expiryDate',
              options: {}
            }],
            showMessage: false
          };
        },
        computed: {
          susvimoData: sync('forms/form@susvimoData')
        },
        methods: {
          getInputLabels: function getInputLabels(target) {
            return {
              input: {
                label: "".concat(this.labels[target].label, "*"),
                description: this.labels[target].description
              },
              checkbox: {
                label: this.labels.checkBox
              }
            };
          },
          handleValueChange: function handleValueChange(item, fieldKey, event) {
            var isCheckbox = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            if (!this.susvimoData[item]) {
              this.susvimoData[item] = {};
            }

            if (isCheckbox) {
              this.susvimoData[item]["".concat(fieldKey, "Unknown")] = !!event;
              return;
            }

            if (!event) {
              this.susvimoData[item][fieldKey] = '';
              return;
            }

            this.susvimoData[item][fieldKey] = event;

            if (fieldKey !== 'availableForReturn') {
              return;
            }

            if (event === this.labels.no) {
              this.showMessage = false;
              return;
            }

            this.showMessage = true;
          }
        }
      });
    }
  }]);

  return SusvimoProductDetail;
}();

export default SusvimoProductDetail;